import { Controller } from "@hotwired/stimulus"

// Массовые действия над строками списка: чекбоксы строк (checkbox), «выбрать все» (all),
// счётчик выбранных (count) и выпадающее меню действий (menu), неактивное без выбора.
// Чекбоксы привязаны к форме массового действия атрибутом form=, поэтому могут жить
// внутри turbo-frame со списком; при перезагрузке фрейма состояние пересчитывается.
// Пункты меню размечены data-bulk-select-menu-action/-title. menu_controller на время открытия
// переносит панель в <body>, поэтому клики по пунктам ловятся через click@document (pick).
export default class extends Controller {
  static targets = ["checkbox", "all", "count", "button", "menu", "dialog", "actionInput", "title", "periodField"]

  checkboxTargetConnected() { this.refresh() }
  checkboxTargetDisconnected() { this.refresh() }

  toggleAll(event) {
    this.checkboxTargets.forEach((cb) => { cb.checked = event.target.checked })
    this.refresh()
  }

  refresh() {
    const count = this.selectedIds().size
    this.countTargets.forEach((el) => { el.textContent = count })
    this.buttonTargets.forEach((el) => {
      el.classList.toggle("disabled", count === 0)
      el.setAttribute("aria-disabled", count === 0)
    })
    if (count === 0 && this.hasMenuTarget) this.menuTarget.open = false
    this.allTargets.forEach((el) => {
      el.checked = count > 0 && this.checkboxTargets.every((cb) => cb.checked || this.isHidden(cb))
    })
  }

  // <summary> нельзя отключить атрибутом disabled — не даём раскрыть меню без выбора.
  guard(event) {
    if (this.selectedIds().size === 0) event.preventDefault()
  }

  pick(event) {
    const item = event.target.closest("[data-bulk-select-menu-action]")
    if (!item) return

    if (this.hasMenuTarget) this.menuTarget.open = false
    this.open(item.dataset.bulkSelectMenuAction, item.dataset.bulkSelectMenuTitle)
  }

  open(action, title) {
    this.actionInputTarget.value = action
    this.titleTarget.textContent = title
    // Для снятия ручного изменения срок не нужен: disabled на fieldset выключает все его поля.
    const needsPeriod = action !== "cancel"
    this.periodFieldTarget.classList.toggle("d-none", !needsPeriod)
    this.periodFieldTarget.disabled = !needsPeriod
    this.dialogTarget.showModal()
  }

  close() {
    this.dialogTarget.close()
  }

  closeOnBackdrop(event) {
    if (event.target === this.dialogTarget) this.dialogTarget.close()
  }

  // Таблица и мобильные карточки дублируют чекбоксы одной строки — считаем уникальные id.
  selectedIds() {
    return new Set(this.checkboxTargets.filter((cb) => cb.checked).map((cb) => cb.value))
  }

  isHidden(el) {
    return el.offsetParent === null
  }
}
